import {
  EstimateResult,
  SimulationEstimate,
} from "../type/simulation-def";

export class EstimateAdapter {
  /**
   * task_result を画面が使う形へ正規化する。
   *
   * `uncertainty_interval` は返らないことがあるため、欠けていても
   * 平均値だけで描画できるよう null に寄せる。
   */
  static toOutputDTO(res: EstimateResult | null | undefined): SimulationEstimate | null {
    if (!res || typeof res.point_estimate !== "number") return null;

    const interval = res.uncertainty_interval ?? null;

    // 介入後のサンプル分布。xs / ys を {x, y}[] に揃える。
    const dist = res.distribution;
    const distribution: { x: number; y: number }[] = [];
    if (Array.isArray(dist?.xs) && Array.isArray(dist?.ys)) {
      const len = Math.min(dist!.xs.length, dist!.ys.length);
      for (let i = 0; i < len; i++) {
        const x = Number(dist!.xs[i]);
        const y = Number(dist!.ys[i]);
        if (Number.isFinite(x) && Number.isFinite(y)) distribution.push({ x, y });
      }
    }

    return {
      outcome: res.outcome,
      pointEstimate: res.point_estimate,
      lower: typeof interval?.lower === "number" ? interval.lower : null,
      upper: typeof interval?.upper === "number" ? interval.upper : null,
      level: typeof interval?.level === "number" ? interval.level : null,
      distribution,
    };
  }
}
